module.exports = __webpack_public_path__ + "static/media/3 Way T.b1995d1d.png";